
import { form15StatusInfoType } from '@/types/Information/Form15';
import { Component, Prop, Vue } from 'vue-property-decorator';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form15ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form15StatusInfoType;

}
